import {
  Input,
  Injector,
  Component,
  OnChanges,
  TemplateRef,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';

import { ISnComponentOrTemplateConfig } from '@lib/common/interfaces';
import { SnComponentOrTemplate } from '@lib/common/types';
import { SnActionConfig } from '@lib/ui/actions';

import { SN_APPBAR_ACTIONS_DATA } from '../../providers';

@Component({
  selector: 'sn-layout-appbar-actions',
  templateUrl: './layout-appbar-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnLayoutAppbarActionsComponent implements OnChanges {
  @Input()
  public items: SnActionConfig[];

  @Input()
  public componentOrTemplate: SnComponentOrTemplate;

  @Input()
  public componentOrTemplateConfig: ISnComponentOrTemplateConfig;

  public isTemplateRef = false;

  public templateContext: Object;
  public componentInjector: Injector;

  constructor(private readonly _injector: Injector) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if ('componentOrTemplate' in changes) {
      this._onComponentOrTemplateChange(changes.componentOrTemplate.currentValue);
    }

    if ('componentOrTemplateConfig' in changes) {
      this._onComponentOrTemplateConfigChange(changes.componentOrTemplateConfig.currentValue || {});
    }
  }

  private _onComponentOrTemplateChange(componentOrTemplate: SnComponentOrTemplate): void {
    this.isTemplateRef = componentOrTemplate instanceof TemplateRef;
  }

  private _onComponentOrTemplateConfigChange(config: ISnComponentOrTemplateConfig): void {
    this.templateContext = { $implicit: config.data };

    const userInjector = config.viewContainerRef && config.viewContainerRef.injector;
    const providers = [{ provide: SN_APPBAR_ACTIONS_DATA, useValue: config.data }];

    this.componentInjector = Injector.create({
      providers,
      parent: userInjector || this._injector,
    });
  }
}
